import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import About from '../../components/about/about';
import FunFact from '../../components/FunFact/FunFact';
import PricingSection from '../../components/PricingSection/PricingSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import CtaSection from '../../components/CtaSection/CtaSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo/finale-gattomio.png';

const HomePage = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollTo) {
            setTimeout(() => {
                const el = document.querySelector(`#${location.state.scrollTo}`);
                if (el) {
                    const offset = 80;
                    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            }, 100);
        }
    }, [location.state]);

    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <Hero hclass={'hero-section'} />
            <ServiceSection hclass={"service-section section-padding"} SectionShowTopimg={true} />
            <About sectionId="garanzia-sicurezza" hclass={'about-section section-padding'} />
            <FunFact hclass={'funfact-section'} />
            <div id="offerta-lancio"><PricingSection pClass={"pricing-section section-padding"} /></div>
            <Testimonial tClass={'testimonial-section section-padding'} />
            <CtaSection hclass={'cta-section'} />
            <BlogSection tClass={'blog-section section-padding pb-200'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;